export const EVENT_CONTENT_UPDATED = 'contentUpdated'
export const EVENT_DIAGRAM_EXPORT = 'export-graph'
export const EVENT_DIAGRAM_HIDE = 'diagram-hide'
export const EVENT_EDITOR_ANNOTATE = 'editor-annotate'
export const EVENT_EDITOR_CANCEL = 'editor-cancel'
export const EVENT_EDITOR_CHANGE = 'editor-change'
export const EVENT_EDITOR_SAVE = 'editor-save'
export const EVENT_ENTER_ROOM = 'enter_room'
export const EVENT_LEAVE_ROOM = 'leave_room'
export const EVENT_OPEN_CHAT = 'openChat'
export const EVENT_RESPONSE_UPDATED = 'answerUpdated'
export const EVENT_STATE_CHANGED = 'stateChanged'
export const EVENT_SUGGESTION_MAKE = 'suggest'
export const EVENT_USER_RATE = 'user_rate'
export const EVENT_USER_IDLE = 'user_idle'
export const EVENT_USER_ACTIVE = 'user_active'
